export default __webpack_public_path__ + "static/media/beauty.6331d180.svg";